import { jsxs as s, jsx as n } from "react/jsx-runtime";
import { c } from "../clsx-OuTLNxxd.js";
import { B as d } from "../Badge-2G452vY2.js";
import { a as v } from "../Tooltip-DQcx7Uge.js";
import '../Comparison.css';const C = "_comparisonContainer_lm6pk_57", f = "_valuesContainer_lm6pk_66", u = "_value_lm6pk_66", $ = "_label_lm6pk_74", k = "_leftBadge_lm6pk_84", b = "_rightBadge_lm6pk_88", N = "_progressBarContainer_lm6pk_112", w = "_hasMiddleValue_lm6pk_118", A = "_progressBar_lm6pk_112", R = "_leftBar_lm6pk_125", x = "_rightBar_lm6pk_128", y = "_separatorContainer_lm6pk_150", M = "_middleBadge_lm6pk_163", W = "_badgeRightAligned_lm6pk_176", a = {
  comparisonContainer: C,
  valuesContainer: f,
  value: u,
  label: $,
  leftBadge: k,
  rightBadge: b,
  progressBarContainer: N,
  hasMiddleValue: w,
  progressBar: A,
  leftBar: R,
  rightBar: x,
  separatorContainer: y,
  middleBadge: M,
  badgeRightAligned: W
}, j = (o, t = "Comparison") => {
  const i = o.reduce((r, l) => r + l, 0), e = 100;
  return i !== e ? (console.warn(`${t} component: The sum of values must equal ${e}. Current sum: ${i}`), !1) : !0;
}, T = ({
  comparisonLabel: o,
  leftValue: t,
  middleText: i = "DRAW",
  middleValue: e = 0,
  rightValue: r,
  tooltipText: l,
  ...m
}) => {
  if (!j([t, e, r]))
    return null;
  const p = `${t}%`, g = `${e}%`, _ = `${r}%`, h = e > 0, B = e > 0 && r <= 20;
  return /* @__PURE__ */ s(
    "div",
    {
      "aria-label": `${o} comparison bar with ${t}% on the left, ${e}% draw in the middle, and ${r}% on the right.`,
      className: a.comparisonContainer,
      "data-cxy-name": "comparison",
      role: "region",
      ...m,
      children: [
        /* @__PURE__ */ s("div", { className: a.valuesContainer, children: [
          /* @__PURE__ */ n("span", { className: a.value, "data-testid": "comparison-left", children: /* @__PURE__ */ s(d, { className: a.leftBadge, children: [
            t,
            "%"
          ] }) }),
          /* @__PURE__ */ s("div", { className: a.label, children: [
            o,
            " ",
            l && /* @__PURE__ */ n(v, { children: l })
          ] }),
          /* @__PURE__ */ n("span", { className: a.value, "data-testid": "comparison-right", children: /* @__PURE__ */ s(d, { className: a.rightBadge, children: [
            r,
            "%"
          ] }) })
        ] }),
        /* @__PURE__ */ s("div", { className: c(a.progressBarContainer, { [a.hasMiddleValue]: h }), children: [
          /* @__PURE__ */ n(
            "div",
            {
              className: `${a.progressBar} ${a.leftBar}`,
              "data-testid": "comparison-left-bar",
              style: { width: p }
            }
          ),
          /* @__PURE__ */ n(
            "div",
            {
              className: a.separatorContainer,
              "data-testid": "comparison-middle-bar",
              style: {
                width: e ? `${e}%` : void 0
              },
              children: e > 0 && /* @__PURE__ */ s(d, { className: c(a.middleBadge, { [a.badgeRightAligned]: B }), children: [
                i,
                " ",
                g
              ] })
            }
          ),
          /* @__PURE__ */ n(
            "div",
            {
              className: `${a.progressBar} ${a.rightBar}`,
              "data-testid": "comparison-right-bar",
              style: { width: _ }
            }
          )
        ] })
      ]
    }
  );
};
export {
  T as Comparison
};
